var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Licenses")]),_c('LicenseTable',{staticClass:"table-padding",attrs:{"license-type":_vm.UserTypeEnum.Student,"show-search":true,"licenses":_vm.licenses,"refresh-licenses":_vm.refreshLicenses},on:{"update:licenses":function($event){_vm.licenses=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }